import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { LinkArrowSvg, one, two } from 'src/assets'
import { GeneralCard } from 'src/components/Global/Cards/Cards'
import { EmergencyTitle } from 'src/components/Global/Text/TitleText'
import { Transaction } from 'src/components/HomePage/ModalsContent/Transaction/Transaction'
import { CallToActionCard } from 'src/Pages/HomePage/homePageStyle'
import { useTypedSelector } from 'src/redux/index'
import CardCarousel from '../GeneralSavings/Carousel/CardCarousel'
import { Balance, TrendTwoSvg } from 'src/assets'

import {
  CardBtnWrapper,
  Container,
  FlexContainerOne,
  FlexContainerTwo,
  SavingsFlexWrapper,
  TargetDataWrapper,
} from './EmergencyStyle'
// import { CardBtnWrapper } from 'src/components/GeneralSavings/style'
interface IEmergencyData {
  id: number
  Icon?: any
  // Icon?: any
  balance?: string
  title?: string
  Amount?: string
  Date?: string
  className?: string
  Desc?: string
}
const EmergencyWrap = () => {
  const investmentData = useTypedSelector((state) => state.invest.all?.plans!)
  const recent = investmentData?.slice(1, 2)

  const portfolio = useTypedSelector(
    (state) => state.portfolios.portfolio.accounts
  )
  const EmergencyCardData: IEmergencyData[] = [
    {
      id: 1,
      balance: portfolio?.saving_plans.emergency,
      title: 'Emergency Savings',
      Icon: Balance,
      className: 'card_one',
    },
    {
      id: 2,
      Icon: TrendTwoSvg,
      balance: portfolio?.total_interest,
      title: 'Interests on savings',
      className: 'card_two',
    },
  ]
  return (
    <Container>
      <EmergencyTitle className="targetTitle">Emergency Savings</EmergencyTitle>
      <SavingsFlexWrapper>
        <FlexContainerOne>
          <CardBtnWrapper>
            <CardCarousel>
              {EmergencyCardData.map(
                ({ id, Icon, title, balance, className }) => {
                  return (
                    <GeneralCard key={id} className={className}>
                      <div className="flex_wrapper">
                        <div className="icon_wrapper">
                          <img src={Icon} alt="" />
                        </div>
                        <div className="balance-wrapper">
                          <p className="title">{title}</p>
                          <h2 className="balance">{balance}</h2>
                        </div>
                      </div>
                    </GeneralCard>
                  )
                }
              )}
            </CardCarousel>

            {/* <div className="btn-container"></div> */}
          </CardBtnWrapper>

          <TargetDataWrapper>
            <div className="target-btn-container">
              <Transaction />
            </div>
          </TargetDataWrapper>
        </FlexContainerOne>

        <FlexContainerTwo>
          {recent?.map((item: any) => (
            <CallToActionCard>
              <div className="header_img">
                <img src={item.image} alt="" className="image" />
              </div>

              <div className="card_body">
                <div className="title_user">
                  <p>{item.plan_name}</p>
                </div>

                <div className="card_text_link">
                  <p>{item.description.substring(0, 60)}...</p>
                  <Link to="/invest" className="call_to_action_link">
                    Join other investors
                    <span>
                      <img src={LinkArrowSvg} alt="" />
                    </span>
                  </Link>
                </div>
              </div>
            </CallToActionCard>
          ))}
        </FlexContainerTwo>

        {/* flex two  ends*/}
      </SavingsFlexWrapper>
    </Container>
  )
}

export { EmergencyWrap }
